<template>
    <div>
        <Force />
    </div>
</template>

<script>
    import Force from './components/force'

    export default {
        name: 'Case',
        components: {
            Force,
        }
    }
</script>

<style lang="scss" scoped>

</style>